<template>
  <div>
    <div v-if="!success">
      <div class="row">
        <div class="col">
          <Input
            label="Código de funcionário"
            placeholder="ex.: 589254786"
            :disabled="codeValid"
            v-model="code"
          />
        </div>
      </div>
      <div class="row" v-if="!codeValid">
        <div class="col">
          <span @click="verificaEmpregado" v-if="!verificando">
            <Button big>Verificar</Button>
          </span>
          <span v-if="verificando">
            <Button big :disabled="true" gray>Verificando...</Button>
          </span>
        </div>
      </div>
      <div v-if="codeValid">
        <div class="row">
          <div class="col">
            <Input
              label="Nome do responsável"
              placeholder="ex.: João da Silva"
              v-model="name"
            />
          </div>
        </div>
        <div class="row">
          <div class="col">
            <label>
              <StrongText>Gênero</StrongText>
            </label>
            <div class="group">
              <radio-button label="Feminino" value="Feminino" v-model="gender" />
              <radio-button label="Masculino" value="Masculino" v-model="gender" />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-lg">
            <Input
              label="Email"
              placeholder="ex.: joao@site.com"
              v-model="email"
            />
          </div>
          <div class="col-12 col-lg">
            <Input
              label="Data de nascimento"
              placeholder="ex.: 10/04/1981"
              type="tel"
              v-mask="'##/##/####'"
              v-model="birth"
            />
          </div>
        </div>
        <div class="row">
          <div class="col">
            <Input
              label="Celular para receber mensagem (Whatsapp)"
              placeholder="ex.: 11 98765 4321"
              type="tel"
              v-mask="['(##) #### ####', '(##) ##### ####']"
              v-model="phone"
            />
          </div>
        </div>
        <div class="row">
          <div class="col">
            <Input
              label="Telefone de Emergência"
              placeholder="ex.: 11 98765 4321"
              type="tel"
              v-mask="['(##) #### ####', '(##) ##### ####']"
              v-model="emergency"
            />
          </div>
        </div>
        <div class="row">
          <div class="col">
            <Input
              label="Se for de carro ao evento, informe a placa do veículo"
              placeholder="ex.: ELV 1555"
              v-mask="'AAA-####'"
              v-model="car"
            />
          </div>
        </div>
        <div class="row" v-for="(crianca, index) in criancas" :key="index">
          <div class="col-12 col-lg">
            <Input
              v-if="criancas == 1"
              :label="`Nome da criança`"
              placeholder="ex.: João da Silva Junior"
              v-model="kids[index].name"
            />
            <Input
              v-else
              :label="`Nome da ${index+1}ª criança`"
              placeholder="ex.: João da Silva Junior"
              v-model="kids[index].name"
            />
          </div>
          <div class="col-12 col-lg">
            <Input
              v-if="criancas == 1"
              :label="`Data de nascimento da criança`"
              placeholder="ex.: 10/02/2008"
              type="tel"
              v-mask="'##/##/####'"
              v-model="kids[index].birth"
            />
            <Input
              v-else
              :label="`Data de nascimento da ${index+1}ª criança`"
              placeholder="ex.: 10/02/2008"
              type="tel"
              v-mask="'##/##/####'"
              v-model="kids[index].birth"
            />
          </div>
        </div>
        <div class="row">
          <div class="col">
            <label>
              <StrongText>Confirmação da leitura do regulamento:</StrongText>
            </label>
            <div class="group">
              <radio-button label="Li e aceito o regulamento" :value="true" v-model="regulamento" />
            </div>
          </div>
        </div>
        <div class="row text-center">
          <div class="col">
            <span @click="send">
              <Button big :disabled="disabled">Cadastrar</Button>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="row" v-if="error || success">
      <div class="col">
        <br/>
        <Alert
          error
          v-if="error"
          v-html="error"
        />
        <Alert
          success
          v-if="success"
          v-html="success"
        />
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/services/api'
import Alert from '@/components/Alert'
import SquareButton from '@/components/SquareButton'
import CheckGender from '@/components/CheckGender'
import Check from '@/components/Check'
import Input from '@/components/Input'
import Button from '@/components/Button'
import StrongText from '@/components/StrongText'

import RadioButton from '@/components/RadioButton'

export default {
  name: 'KidsInscrevase',
  data: () => ({
    disabled: false,
    error: false,
    success: false,
    codeValid: false,
    verificando: false,
    code: '',
    name: '',
    email: '',
    birth: '',
    phone: '',
    emergency: '',
    gender: '',
    regulamento: false,
    car: '',
    kids: [
      {
        name: '',
        birth: ''
      },
      {
        name: '',
        birth: ''
      },
      {
        name: '',
        birth: ''
      },
      {
        name: '',
        birth: ''
      },
      {
        name: '',
        birth: ''
      },
      {
        name: '',
        birth: ''
      },
      {
        name: '',
        birth: ''
      },
      {
        name: '',
        birth: ''
      },
    ],
    criancas: 1
  }),
  methods: {
    async verificaEmpregado() {
      this.verificando = true

      try {

        // const { data } = await api.checkEmployer(this.code)

        this.criancas = 2

        if (this.criancas == 0) {
          setTimeout(()=> this.verificando = false, 1000)
          this.error = 'Você não tem vagas disponíveis para dependentes.'
        } else {
          this.codeValid = true
        }

      } catch (error) {
        setTimeout(()=> this.verificando = false, 1000)
        this.error = 'Código de funcionário não existe.'
      }


    },
    async send() {
      if(this.disabled)
        return

      this.error = false
      this.success = false
      this.disabled = true

      try {

        let str = this.birth.split('/')

        await api.kid({
          code: this.code,
          name: this.name,
          email: this.email,
          birth: `${str[2]}-${str[1]}-${str[0]}`,
          phone: this.phone,
          emergency: this.emergency,
          gender: this.gender,
          car: this.car,
          regulamento: this.regulamento,
          kids: this.kids.filter(item => item.name).map(item => {
            let str = item.birth.split('/')

            return {
              ...item,
              birth: `${str[2]}-${str[1]}-${str[0]}`
            }
          })
        })

        this.code = ''
        this.name = ''
        this.email = ''
        this.birth = ''
        this.size = ''
        this.phone = ''
        this.emergency = ''
        this.gender = ''
        this.car = ''

        this.success = 'Cadastro realizado com sucesso! Esperamos você no evento'

      } catch (response) {

        const error = Object.values(response.response.data.errors)
        this.error = error[0][0]
        setTimeout(() => this.disabled = false, 1000)

      }
    },
    adicionaCrianca() {
      if(this.criancas < 4)
        this.criancas++
    }
  },
  components: {
    Input,
    Check,
    Button,
    CheckGender,
    SquareButton,
    StrongText,
    RadioButton,
    Alert
  }
}
</script>

<style lang="scss" scoped>
.text-center {
  text-align: center
}
.group {
  margin-top: 11px;
  margin-bottom: 60px;
}
</style>
